"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarSpacer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BAR_SPACER = "flex flex-grow";
var BarSpacer = function () { return (0, jsx_runtime_1.jsx)("span", { className: BAR_SPACER }, void 0); };
exports.BarSpacer = BarSpacer;
